var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.792 8.215-.006-.003L1.879.973a.906.906 0 0 0-.88.088.996.996 0 0 0-.323.364 1.033 1.033 0 0 0-.117.478v4.63a1 1 0 0 0 .218.625.945.945 0 0 0 .554.338l9.221 1.76a.157.157 0 0 1 .093.056.167.167 0 0 1 0 .209.157.157 0 0 1-.093.056l-9.22 1.76a.945.945 0 0 0-.555.338 1 1 0 0 0-.218.625v4.63c0 .16.038.317.11.457.074.14.18.26.309.348a.926.926 0 0 0 .9.085l16.907-7.198.007-.004c.228-.1.421-.268.558-.482a1.338 1.338 0 0 0 0-1.439 1.277 1.277 0 0 0-.558-.482z",
    fill: "#1C2F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b4efe4a58b73f89b6bd4212e81036b24.svg";
export { ForwardRef as ReactComponent };